export default {
  namespaced: true,
  state: {
    tabs: [],
    tab: null
  },
  mutations: {
    addTabToRecentTabs(state, tab) {
      tab.buttons = []

      state.tab = tab

      var index = state.tabs.findIndex(x => tab.id.includes(x.id)) // preventing allowMultiple tabs
      if (index === -1)
        state.tabs.push(tab)
    },
  },
  getters: {
    isTabInRecentTabs: state => (id) => {
      return state.codes.findIndex(x => x.id === id) > -1
    },
    getRecentTabs: state => {
      return state.tabs
    },
    getCurrentTab: state => {
      return state.tab
    }
  },
}